import React from 'react'
import { useTranslation } from 'react-i18next'

// Shared brand typography for the header and navigation.
const Brand = () => {
  const { t } = useTranslation()
  const [first_word, ...other_words] = t('Sport Vokrug.').split(' ')
  return (
    <span className="inline-flex items-center gap-xs whitespace-nowrap font-header font-bold">
      <span className="text-text-base">
        {first_word}{' '}
        <span className="text-primary">{other_words.join(' ')}</span>
      </span>
    </span>
  )
}
export default Brand
